import { render, staticRenderFns } from "./Incubator.vue?vue&type=template&id=6033b892"
import script from "./Incubator.vue?vue&type=script&lang=js"
export * from "./Incubator.vue?vue&type=script&lang=js"
import style0 from "./Incubator.vue?vue&type=style&index=0&id=6033b892&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports